

const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;


export const updateOrder = async (orderId, orderData) => {
        const token = localStorage.getItem('token'); 
  const formData = new FormData();
  formData.append('_method', 'PATCH');
  for (const key in orderData) {
    const value = orderData[key];
    if (value !== undefined) {
      formData.append(key, value === null ? '' : value);
    }
  }

  try {
    const response = await fetch(`${API_BASE_URL}/admin/lead/leads/orders/${orderId}`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: formData,
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw errorData
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error updating order:', error);
    throw error;
  }
};